module.exports = __webpack_public_path__ + "media/customizations/cypressgreenlife/back-00a1b9f750329161ba370ee1e64cae10.jpg";